import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Formik } from "formik";
import * as Yup from "yup";
import { Autocomplete, Button, FormHelperText, IconButton, TextField } from "@mui/material";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useSnackbar } from "notistack";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";
import { EditOutlined } from "@mui/icons-material";

const JobSkillDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  dialogAction: EDialogAction;
}) => {
  const theme = useTheme();
  const [jobTitle, setJobTitle] = useState(props.data);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formRef = useRef<any>();
  const [value, setValue] = useState({});
  const [skillList, setSkillList] = useState<any[]>([]);
  const limit = 10;
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [dialogAction, setDialogAction] = useState(EDialogAction.view);

  useEffect(() => {
    setJobTitle(props.data);
  }, [props.data]);

  useEffect(() => {
    getSkillList();
  }, []);

  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const createJobSkill = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/job-title-skills`;

      const res = await axiosInstance.post(url, {
        job_title_id: props.data.id,
        skill_id: data.skill_id,
      });
      enqueueSnackbar("Skill Created Successfully!!!", { variant: "success" });
      handleClose("created");
    } catch (err) {
      enqueueSnackbar("Skill Creation Unsuccessful!!!", { variant: "error" });
      console.error(err);
    }
  };
  const getSkillList = async () => {
    try {
      const response = await axiosInstance.get(
        `/v1/skills?type=${theme.theme}&items_per_page=${limit}`,
        {}
      );

      const data = response.data;
      setSkillList(data.result.data);

      setTotalItems(data.result.length);

    } catch (err) {
      console.log(err);
    }
  };

  const handleInputChange = async (event: any) => {
    const inputValue = event.target.value ??  '';
    try {
      const response = await axiosInstance.get(`/v1/skills?type=${theme.theme}&items_per_page=${limit}&keyword=${inputValue}`);
      const data = response.data;
      setSkillList(data.result.data);
    } catch (error) {
      console.error('Error fetching skills:', error);
    }
  };

  return (
    <>
      {" "}
      {jobTitle == null ? (
        <div></div>
      ) : (
        <Dialog
          open={props.open}
          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
          className="job-create-form"
        >
          {props.dialogAction == EDialogAction.create ? (
            <DialogTitle>Add Skill for Job </DialogTitle>
          ) : (
            <></>
          )}

          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              initialValues={{
                job_title_id: jobTitle.id,
                skill_id: +"",
              }}
              initialTouched={{ zip: true }}
              validationSchema={Yup.object().shape({
                job_title_id: Yup.number().required("Job Title is Required"),
                skill_id: Yup.number().required("Skill is Required"),
              })}
              onSubmit={createJobSkill}
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-cols-2">
                  <div className="flex flex-col space-y-1 mr-6 mb-4 mt-2">

                    <TextField
                      disabled
                      id="outlined-multiline-flexible"
                      variant="outlined"
                      onChange={handleChange}
                      value={jobTitle.title}
                      placeholder={jobTitle.title}
                      label="Job Title"
                      name="job_title_id"
                      error={Boolean(
                        errors.job_title_id && touched.job_title_id
                      )}
                      helperText={
                        errors.job_title_id &&
                        touched.job_title_id &&
                        String(errors.job_title_id)
                      }
                    />
                  </div>

                  <div className="flex flex-col space-y-1 mr-6 mb-4 mt-2">
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={skillList}
                      getOptionLabel={(option) => option.skill_name}
                      onChange={(e, value) =>
                        setFieldValue("skill_id", value? value.id : null)
                      }
                      onOpen={handleInputChange}
                      onInputChange={handleInputChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="skill_id"
                          // onChange={handleChange}
                          value={values.skill_id}
                          placeholder="Select the Skill"
                          label="Skill"
                          error={Boolean(touched.skill_id && errors.skill_id)}
                          helperText={
                            errors.skill_id &&
                            touched.skill_id &&
                            String(errors.skill_id)
                          }                         
                        />
                      )}
                    />


                  </div>

                  <div>
                    <div className="flex space-x-4">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Add
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        Close
                      </Button>
                      <IconButton
                        color="primary"
                        onClick={() => {
                          window.location.href = `/admin/skills`;
                        }}
                      >
                        <EditOutlined />
                      </IconButton>

                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default JobSkillDialogBox;
